import { PropsWithChildren } from 'react'
import { useGetContractsApiHealthQuery } from '../../../redux/api/contractsApi'
import { useGetCustomersApiHealthQuery } from '../../../redux/api/customerApi'
import { useTranslation } from 'react-i18next'
import { isDev } from '../../../types/constants'

export function BackendChecker(props: PropsWithChildren) {
  const { t } = useTranslation('common')
  const pollingInterval = 1000 * 60 * 5
  const skip = isDev
  const contractsApiHealth = useGetContractsApiHealthQuery(undefined, { pollingInterval: pollingInterval, skip })
  const customersApiHealth = useGetCustomersApiHealthQuery(undefined, { pollingInterval: pollingInterval, skip })
  if (
    contractsApiHealth.isError ||
    contractsApiHealth.currentData?.status === 'Unhealthy' ||
    customersApiHealth.isError ||
    customersApiHealth.currentData?.status === 'Unhealthy'
  ) {
    return (
      <h1 style={{ marginTop: '50px', marginLeft: '50px', color: '#fff' }}>
        {false && ` ${t('BACKEND_SERVICES_UNAVAILABLE') + '. ' + t('DUE_TO_NETWORK_CONNECTIVITY_PROBLEMS')}.`}
        {true && ` ${t('BACKEND_SERVICES_UNAVAILABLE') + '. ' + t('SOMETHING_WENT_WRONG')}`}{' '}
        <button onClick={() => window.location.reload()}>{t('PLEASE_CHECK_AGAIN')}</button>
      </h1>
    )
  }
  return props.children
}
